import { AudioPlayer, DefaultText, MusicNote, styleVariables } from '@lib/common';
import { AudioFileContainerDirection } from '../audio-file-base';
import styled from 'styled-components';
import { Space } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledContainer = styled(Space).withConfig({
  displayName: "audio-file-previewcomponent__StyledContainer",
  componentId: "sc-1p3m745-0"
})(["border:", ";width:100%;border-radius:", ";"], function (_ref) {
  var $border = _ref.$border;
  return $border ? "1px solid ".concat(styleVariables.colors.grey30) : undefined;
}, styleVariables.borderRadius.medium);
var StyledHorizontalContainer = styled.div.withConfig({
  displayName: "audio-file-previewcomponent__StyledHorizontalContainer",
  componentId: "sc-1p3m745-1"
})(["width:100%;display:flex;align-items:center;justify-content:space-between;gap:16px;"]);
var StyledHeader = styled(Space).withConfig({
  displayName: "audio-file-previewcomponent__StyledHeader",
  componentId: "sc-1p3m745-2"
})(["width:100%;display:flex;justify-content:space-between;align-items:center;"]);
var StyledInfo = styled(Space).withConfig({
  displayName: "audio-file-previewcomponent__StyledInfo",
  componentId: "sc-1p3m745-3"
})(["display:flex;gap:16px;align-items:center;"]);
var StyledAudioIconContainer = styled.div.withConfig({
  displayName: "audio-file-previewcomponent__StyledAudioIconContainer",
  componentId: "sc-1p3m745-4"
})(["width:32px;height:32px;display:flex;justify-content:center;align-items:center;background-color:", ";border-radius:", ";"], styleVariables.colors.primary20, styleVariables.borderRadius.medium);
var StyledAudioPlayer = styled(AudioPlayer).withConfig({
  displayName: "audio-file-previewcomponent__StyledAudioPlayer",
  componentId: "sc-1p3m745-5"
})(["width:100%;"]);
var StyledHorizontalAudioPlayerContainer = styled.div.withConfig({
  displayName: "audio-file-previewcomponent__StyledHorizontalAudioPlayerContainer",
  componentId: "sc-1p3m745-6"
})(["flex:1;"]);
var StyleFileName = styled(DefaultText).withConfig({
  displayName: "audio-file-previewcomponent__StyleFileName",
  componentId: "sc-1p3m745-7"
})(["font-size:", ";"], styleVariables.font.fontSizeSmall);
var StyleFileSize = styled(StyleFileName).withConfig({
  displayName: "audio-file-previewcomponent__StyleFileSize",
  componentId: "sc-1p3m745-8"
})(["color:", ";"], styleVariables.colors.grey70);
export var AudioFilePreview = function AudioFilePreview(_ref2) {
  var source = _ref2.source,
      fileSize = _ref2.fileSize,
      fileName = _ref2.fileName,
      onPlay = _ref2.onPlay,
      onReplay = _ref2.onReplay,
      isAllowedToPause = _ref2.isAllowedToPause,
      isAllowedToReplay = _ref2.isAllowedToReplay,
      _ref2$isAutoPlay = _ref2.isAutoPlay,
      isAutoPlay = _ref2$isAutoPlay === void 0 ? false : _ref2$isAutoPlay,
      _ref2$shouldShowExtra = _ref2.shouldShowExtraInfo,
      shouldShowExtraInfo = _ref2$shouldShowExtra === void 0 ? true : _ref2$shouldShowExtra,
      _ref2$isAppliedRule = _ref2.isAppliedRule,
      isAppliedRule = _ref2$isAppliedRule === void 0 ? false : _ref2$isAppliedRule,
      numberOfReplays = _ref2.numberOfReplays,
      _ref2$direction = _ref2.direction,
      direction = _ref2$direction === void 0 ? AudioFileContainerDirection.VERTICAL : _ref2$direction,
      hasPlayed = _ref2.hasPlayed,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled;

  var renderVerticalContent = function renderVerticalContent() {
    var audioPlayerConfig = {
      isAllowedToPause: disabled ? false : isAllowedToPause,
      isAllowedToReplay: disabled ? false : isAllowedToReplay,
      isAllowedToSeek: disabled ? false : true,
      isAutoPlay: disabled ? false : isAutoPlay
    };
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [shouldShowExtraInfo && /*#__PURE__*/_jsx(StyledHeader, {
        children: /*#__PURE__*/_jsxs(StyledInfo, {
          children: [/*#__PURE__*/_jsx(StyledAudioIconContainer, {
            children: /*#__PURE__*/_jsx(MusicNote, {})
          }), /*#__PURE__*/_jsxs(StyleFileName, {
            children: [fileName, /*#__PURE__*/_jsxs(StyleFileSize, {
              children: [" | ", fileSize]
            })]
          })]
        })
      }), /*#__PURE__*/_jsx(StyledAudioPlayer, {
        source: source,
        onPlay: disabled ? undefined : onPlay,
        onReplay: disabled ? undefined : onReplay,
        numberOfReplays: disabled ? 0 : numberOfReplays,
        isAppliedRule: isAppliedRule,
        audioPlayerConfig: audioPlayerConfig,
        hasPlayed: hasPlayed,
        disabled: disabled
      })]
    });
  };

  var renderHorizontalContent = function renderHorizontalContent() {
    var audioPlayerConfig = {
      isAllowedToPause: disabled ? false : isAllowedToPause,
      isAllowedToReplay: disabled ? false : isAllowedToReplay,
      isAllowedToSeek: disabled ? false : true,
      isAutoPlay: disabled ? false : isAutoPlay
    };
    return /*#__PURE__*/_jsxs(StyledHorizontalContainer, {
      children: [shouldShowExtraInfo && /*#__PURE__*/_jsxs(StyledInfo, {
        direction: 'horizontal',
        align: "center",
        children: [/*#__PURE__*/_jsx(StyledAudioIconContainer, {
          children: /*#__PURE__*/_jsx(MusicNote, {})
        }), /*#__PURE__*/_jsxs(StyleFileName, {
          children: [fileName, /*#__PURE__*/_jsxs(StyleFileSize, {
            children: [" | ", fileSize]
          })]
        })]
      }), /*#__PURE__*/_jsx(StyledHorizontalAudioPlayerContainer, {
        children: /*#__PURE__*/_jsx(AudioPlayer, {
          source: source,
          onPlay: disabled ? undefined : onPlay,
          onReplay: disabled ? undefined : onReplay,
          isAppliedRule: isAppliedRule,
          numberOfReplays: disabled ? 0 : numberOfReplays,
          audioPlayerConfig: audioPlayerConfig,
          hasPlayed: hasPlayed,
          disabled: disabled
        })
      })]
    });
  };

  var renderContent = function renderContent(direction) {
    switch (direction) {
      case AudioFileContainerDirection.HORIZONTAL:
        {
          return renderHorizontalContent();
        }

      case AudioFileContainerDirection.VERTICAL:
        {
          return renderVerticalContent();
        }
    }
  };

  return /*#__PURE__*/_jsx(StyledContainer, {
    direction: "vertical",
    $padding: direction,
    $border: shouldShowExtraInfo,
    children: renderContent(direction)
  });
};